import { Close } from '@mui/icons-material';
import { Box, DialogActions, DialogContent, Grid, IconButton, Stack, styled } from '@mui/material';
import { useForm, FormProvider, FieldValues } from 'react-hook-form';
import { IBooleanQueryBuilderDTO, IJob, amplitude } from 'wisestep-api';
import {
  ControlledTextInput,
  TagsInput,
  theme,
  WsButton,
  WsColors,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../../../../context';
const CardTheme = styled(Grid)(() => ({
  borderRadius: theme.spacing(0.5),
  backgroundColor: WsColors.TertiaryShades50,
  padding: theme.spacing(1),
}));
interface CustomiseBooleanQueryProps {
  closeDialog: () => void;
  handleClose: (customQuery: IBooleanQueryBuilderDTO | null) => void;
  job?: IJob;
}

interface FormData {
  jobTitle: string;
  jobDescription: string;
  skills: string[];
}

const CustomiseBooleanQuery = ({ closeDialog, handleClose, job }: CustomiseBooleanQueryProps) => {
  const workspace = useWorkspaceContext();

  const methods = useForm<FormData>({
    defaultValues: {
      jobTitle: job?.title,
      jobDescription: job?.description,
      skills: job?.skills,
    },
  });
  const submitAction = (data: FieldValues) => {
    amplitude('Job_Listing_job_card_AIboolean_query_Customize', {
      clickedOn: 'Customize(AI Boolean)',
      workspaceName: workspace.name,
      pageName: 'JobListing',
      planType: workspace.planType,
      pageUrl: window.location.href,
      interfaceType: 'Web',
    });
    const query: IBooleanQueryBuilderDTO = {
      jobTitle: data.jobTitle,
      jobDescription: data.jobDescription,
      requiredSkills: data.skills,
    };
    handleClose(query);
  };
  return (
    <FormProvider {...methods}>
      <Box component="form" onSubmit={methods.handleSubmit(submitAction)}>
        <CardTheme
          xs={12}
          container
          sx={{ justifyContent: 'space-between', pl: 2, alignItems: 'center' }}
        >
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
            Customise Boolean Query
          </WsTypography>
          <IconButton onClick={closeDialog}>
            <Close />
          </IconButton>
        </CardTheme>
        <DialogContent dividers sx={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}>
          <Box py={2}>
            <Stack pb={2} spacing={1} direction="column">
              <ControlledTextInput
                name="jobTitle"
                labelText="Job Title"
                type="text"
                fullWidth
                id="job-title"
                placeholder="Eg, Java Developer"
                variant="outlined"
                size="small"
              />
            </Stack>
            <Box pb={1}>
              <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
                Skills
              </WsTypography>
            </Box>
            <TagsInput
              onTagsChange={(value: string[]) => methods.setValue('skills', value)}
              initialValue={job?.skills || []}
              placeholder="Enter Skills, comma separated. "
              multiple={true}
              size="small"
              name="skills"
            />
            <Box py={2}>
              <ControlledTextInput
                name="jobDescription"
                labelText="Job Description"
                type="text"
                fullWidth
                id="job-description"
                placeholder="Type something..."
                variant="outlined"
                required
                size="medium"
                multiline
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Grid container item xs={12} justifyContent="flex-end" py={2} spacing={2}>
            <Grid item>
              <WsButton variant="outlined" size="large" onClick={() => handleClose(null)}>
                GoBack
              </WsButton>
            </Grid>
            <Grid item>
              <WsButton variant="contained" size="large" type="submit">
                Customize
              </WsButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Box>
    </FormProvider>
  );
};
export default CustomiseBooleanQuery;
